export interface Semestre {
    semestre: number;
    abreviacao: string
    nome: string;
}

export const semestre1: Semestre = {semestre: 1, abreviacao: 'S1', nome: 'Semestre 1'};
export const semestre2: Semestre = {semestre: 2, abreviacao: 'S2', nome: 'Semestre 2'};

export const semestres: Semestre[] = [
    semestre1,
    semestre2
];
